<template>
  <div>
    <FormulateInput
      v-if="layer.personalized.numberic"
      type="number"
      :name="layer.id"
      :validation-name="label"
      :label="label"
      :help="layer.personalized.help"
      :placeholder="layer.personalized.placeholder"
      input-class="form-control"
      :validation="validation()"
      @click="ClickDeleteDefauld"
    />
    <div  v-else>

      <!-- <FormulateInput
      :name="layer.id"
      :validation-name="label"
      :label="label + count"
      :help="layer.personalized.help"
      :placeholder="layer.personalized.placeholder"
      input-class="form-control"
      :validation="validation()"
      :maxlength="max"
      @click="ClickDeleteDefauld"
    /> -->
      <FormulateInput
      :name="this.layer.id"
      :placeholder="layer.personalized.placeholder"
      input-class="form-control"
      :maxlength="max"
      :valueinput="valueinput"
      :contentLayer=layer
      @click="ClickDeleteDefauld"
      type="textblur"
    />

    </div>
    
  </div>
</template>
<script>
import { get } from 'lodash'
export default {
  name: 'layer-text-field',
  data() {
    return {
      val: ''
    }
  },
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    val(v) {
      this.$emit('input', v)
    }
  },
  computed: {
    //...mapGetters(['personalized']),
    required() {
      return get(this.layer, 'personalized.required', false)
    },
    fieldConfig() {
      const { personalized, layer } = this
      return [
        this.layer.id,
        {
          rules: [
            {
              required: this.required,
              message: `${this.label} is required`
            }
          ],
          initialValue: get(personalized, layer.id)
        }
      ]
    },
    label() {
      return get(this.layer, 'personalized.title', this.layer.title)
    },
    count() {
      const { max, personalized, layer } = this
      if (max) {
        var val = get(personalized, layer.id) || ''
        return ` (${val.length}/${max})`
      }
      return ''
    },
    max() {
      return get(this.layer, 'personalized.max', '')
    },
    valueinput(){
      return this.personalized[this.layer.id];
    }
  },
  methods: {
    validation() {
      const { min, max, required } = get(this.layer, 'personalized')
      var rules = []
      if (required) {
        rules.push(['required'])
      }
      if (min) {
        rules.push(['min', min])
      }
      if (max) {
        rules.push(['max', max])
      }
      return rules
    },
    ClickDeleteDefauld(e){
      if(e.target.value === this.layer['values'][0]['text']){
        e.target.value = ''
      }
      // e.target.select()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/TextField.vue